import ProfilePost from "../StoryHeading.jsx";
import React from "react";

export default class StoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      likeCount: 0,
      posts: [],
      postMap: [],
      isFollower: false
    }
    console.log("LOOK HERE", props.followerList);
    console.log(props)
    this.componentDidMount();
  }

componentDidMount(){
  this.loadPosts();
}

async loadPosts () {
  const postsResponse = await fetch(process.env.REACT_APP_API_PATH+"/posts?authorID=" + this.props.userId + "&parentID=", {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem("token")
    }
    });

  const followerResponse = await fetch(process.env.REACT_APP_API_PATH + "/connections?fromUserID=" + sessionStorage.getItem('user'), {
    method: "get",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem("token")
    }
  });

  const postsObject = await postsResponse.json();
  const follower = await followerResponse.json();

  const followCons = follower[0].filter(conn=>conn.attributes.type==="friend");

  //if viewing your own profile
  if(this.props.userId == sessionStorage.getItem("user")){
    this.setState({
      isFollower: true
    })
  }
  else{
    for(let conn of followCons){
      //if profile user and logged in user are friends
      if(conn.toUser.id == this.props.userId){
        this.setState({
          isFollower: true
        })
      }
    }
  }

  var filtered = postsObject[0].filter(post => this.state.isFollower || post.attributes.storyPrivacy == "Public")
  var mapping = filtered.map(post => (<ProfilePost key={post.id} post={post} type={this.props.type}/>))

  this.setState({
    posts: mapping
  })
}

render(){
  return(
    <div className="following-stories">
      {this.state.posts}
    </div>
    );
}
}